import React from 'react';
import './ProfileStory.css';

const ProfileStory = () => {
  const handleNav = (e, sectionId) => {
    e.preventDefault();
    const scrollWithOffset = () => {
      const el = document.getElementById(sectionId);
      if (!el) return false;
      const topAdHeight = window.innerHeight * 0.1; // 10vh
      const headerHeight = 80; // ~header height
      const offset = topAdHeight + headerHeight + 20;
      const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      return true;
    };
    const waitAndScroll = (retries = 25) => {
      if (scrollWithOffset()) return;
      if (retries <= 0) return;
      setTimeout(() => waitAndScroll(retries - 1), 100);
    };
    if (window.location.hash && window.location.hash !== '#' && !window.location.hash.startsWith('#' + sectionId)) {
      window.location.hash = '#';
      waitAndScroll(25);
    } else {
      waitAndScroll(25);
    }
  };

  return (
    <section id="mystory" className="section profile">
      <div className="container profile-grid">
        {/* Page Title */}
        <h1 className="profile-title">My Story</h1>
        {/* Image space */}
        <div className="profile-image card">
          <img
            src="/mystory.jpg"
            alt="Illiyas KP - Organic Farmer"
          />
        </div>

        {/* Content */}
        <div className="profile-content">
          <h2 className="profile-heading">Illiyas KP</h2>
          
          <p className="profile-text">
            Illiyas K P, hailing from Kozhikode, Kerala, is an experienced organic farmer, seed keeper, and project consultant with over 17 years of expertise in organic farming and more than 23 years of active involvement in the organic farming movement. His journey into sustainable agriculture began in the early 2000s through his association with the Kerala Jaiva Karshaka Samithi (KJKS), which inspired his commitment to traditional food systems, agroecology, and native seed conservation.
          </p>

          <p className="profile-text">
            From 2009 to 2012, he served as Project Coordinator of the Agro-Biodiversity Restoration Project at Erimayoor Panchayath, Palakkad, organized by the Kerala State Biodiversity Board with technical support from Thanal, Thiruvananthapuram. Over the years, Illiyas has worked as Field Coordinator and Consultant for several major initiatives, including projects of the UNDP, the Sálim Ali Foundation, and the Kerala Forest Department, focusing on the promotion of traditional farming practices, conservation of native seeds, and sustainable agriculture planning across Kerala.
          </p>

          <p className="profile-text">
            His notable contributions include serving as Technical Consultant for the Chinnar Tribal Agri-project (Punarjeevanam) and as Organic Farming Consultant for the Mahila Kisan Sashakthikarana Pariyojana (MKSP) under NRLM. Between 2015 and 2020, he played a key role in the Holistic, Integrated, Eco-friendly, Sustainable Development Project of Vellangallur Panchayat, Thrissur. More recently, he coordinated UNDP–SAF projects in Idukki and worked on the India High Range Mountain Landscape Project (IHRML), focusing on conservation and propagation of traditional practices and seed varieties.
          </p>

          <p className="profile-text">
            Alongside project work, Illiyas has been deeply involved in the organic farming movement. He was State Secretary of One Earth One Life (2010–2012), later served as State Secretary of Kerala Jaiva Karshaka Samithi (2012–2015), and became a Managing Committee Member of the Organic Farming Association of India (2015–2017). Since 2018, he has been serving as the National President of the Organic Farming Association of India (OFAI), leading initiatives for farmer networking and knowledge sharing at the national level. In 2012, he also captained the Traditional Seed Caravan organized by Thanal, from Kasaragod to Thrissur, a landmark campaign for native seed conservation.
          </p>

          <p className="profile-text">
            As a farmer, Illiyas has cultivated diverse crops across different regions of Kerala, ranging from paddy, tubers, fruits vegetables, turmeric, and ginger. At present, he manages a 4-acre organic farm in Shoranur, where he conserves different rice varieties, tuber varieties, fruits and vegetables while maintaining a 'Purayidakrishi' model. He is also part of the collective Akavayal, which conserves more than 100 traditional rice seed varieties in Shoranur, Kerala.
          </p>

          <p className="profile-text">
            Illiyas has authored the Malayalam book "Nelkrishi Jaivareethiyil" (2012) and published booklets such as "Njattuvela Krishi" and "pachakkarikrishi Thattu" He has written over 60 articles on organic farming and conservation in One Earth One Life monthly magazine since 2007, along with around 30 articles in leading Malayalam magazines such as Mathrubhumi Weekly, Manorama Online, Media One, Chandrika Weekly, Ezhuthu Magazine, Patabhedam, The Critic, and Keraleeyam. He has also been featured in multiple interviews on All India Radio (Akashvani).
          </p>

          <p className="profile-text">
            Internationally, Illiyas contributes as a steering committee member of the research study Agroecology for Climate Change, undertaken by Hohenheim University (Germany) and the University of British Columbia (Canada). His work continues to bridge grassroots farmer knowledge with scientific research, policy advocacy, and sustainable agricultural development.
          </p>

          <div className="profile-cta">
            <a className="btn" href="#contact" onClick={(e) => handleNav(e, 'contact')}>Contact</a>
            <a className="btn btn-outline" href="#services" onClick={(e) => handleNav(e, 'services')}>Services</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileStory;
